import React from 'react';

// Minimal inline formatter: converts **bold** segments into <strong> nodes.
// Keeps things dependency-free (no markdown library needed for the demo).
export function formatText(text) {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
